// resources/js/nova-override.js
function clearTokens() {
    try {
        localStorage.removeItem('graphql_token')
        localStorage.removeItem('imp_graphql_token')
    } catch (e) {
        console.error('Error clearing tokens:', e);
    }
}

document.addEventListener('submit', (e) => {
    const form = e.target
    if (form?.matches('form[action$="/logout"], form[action$="/nova/logout"]')) {
        clearTokens();
    }
})

window.addEventListener('beforeunload', () => {
    clearTokens();
})

window.addEventListener('inertia:before', (e) => {
    const v = e.detail?.visit
    if (!v) return
    
    console.log('Inertia visit:', v);

    const url = new URL(v.url, window.location.origin)
    if (v.method?.toLowerCase() === 'post' && url.pathname === '/logout') {
        clearTokens(); // clear before the request leaves
    }
})


document.addEventListener('DOMContentLoaded', () => {
    
    const elements = document.querySelectorAll('.bg-gray-100');
    elements.forEach(el => {
        el.classList.remove('bg-gray-100');
        el.classList.add('bg-stapp-bg');
    });

});
